import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';

@Component({
    selector: 'app-chart-broker-module-qty',
    templateUrl: './chart-broker-module-qty.component.html',
    styleUrls: ['./chart-broker-module-qty.component.css']
})
export class ChartBrokerModuleQtyComponent implements OnInit {
    @Input() brokerModuleQty: any[];
    @ViewChild('chartRevQuantityContainer') chartRevQuantityContainer: ElementRef;

    brokerCount: number = 0;

    view: any[] = [280, 180];

    // options
    showXAxis: boolean = false;
    showYAxis: boolean = true;
    gradient: boolean = false;
    showLegend: boolean = false;
    showXAxisLabel: boolean = false;
    showGridLines: boolean = true;
    xAxisLabel: string = 'Months';
    showYAxisLabel: boolean = false;
    yAxisLabel: string = 'Audits';
    animations: boolean = true;
    rotateXAxisTicks: boolean = false;
    maxXAxisTickLength: number = 1;
    trimXAxisTicks: boolean = true;

    colorScheme = {
        domain: ['#28a745', '#ffc107', '#dc3545']
    };
    bluePalette = {
        domain: ['#4e9c89']
    };

    constructor() {
    }

    ngOnInit() {
        this.brokerCount = this.brokerModuleQty.length;

        // Use setTimeout to allow the view to be rendered before setting the width of the chart
        setTimeout(() => this.view = [this.chartRevQuantityContainer.nativeElement.offsetWidth, 180]);
    }

}
